import React from 'react'
import PropTypes from 'prop-types'

import Tag from '../Tag'

const TagsViewer = ({ tags, Id }) => (
  <ul style={{ padding: 0, margin: 0, display: 'inline' }}>
    {tags.length > 0 &&
      tags.map(({ name }) => (
        <Tag key={`tag-${Id}-${name}`} view>
          {name}
        </Tag>
      ))}
  </ul>
)

TagsViewer.propTypes = {
  tags: PropTypes.array,
  Id: PropTypes.string,
}

TagsViewer.defaultProps = {
  tags: [],
  Id: '',
}

export default TagsViewer
